// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".divider[data-v-0f0aa9d6]{display:flex;flex-direction:row;color:#909090}.divider[data-v-0f0aa9d6]:after,.divider[data-v-0f0aa9d6]:before{content:\"-\";margin:auto}.divider[data-v-0f0aa9d6]:before{margin-right:10px}.divider[data-v-0f0aa9d6]:after{margin-left:10px}a[data-v-0f0aa9d6]{color:#2eac68;-webkit-text-decoration-line:none;text-decoration-line:none}", ""]);
// Exports
module.exports = exports;
